import Group from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { OSM } from 'ol/source.js';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Style, Fill, Stroke, Circle } from 'ol/style';

// Temporärer Layer zum Ansehen erzeugen und exportieren
const survSourceTemp = new VectorSource();
const survVectorTemp = new VectorLayer({
    source: survSourceTemp
});

// Source/Layer für die Umfrage erzeugen
const survSource = new VectorSource({
    format: new GeoJSON(),

});

const survLayer = new VectorLayer({
    title: 'Umfrage',
    visible: true,
    source: survSource,
    id: "survLayer",
    // style: new Style({
    //     fill: new Fill({
    //         color: [255, 255, 255, 0.5],
    //     }),
    //     stroke: new Stroke({
    //         color: 'grey',
    //         width: 3,
    //     }),
    //     point: new Circle({
    //         color: "grey",
    //         radius: 10,
    //     })
    // }),
});



// Verschiedene Hintergrundlayer in einer Gruppe erstellen
const BASELAYER = new Group({
    'id': 'baselayer',
    layers: [
        new TileLayer({
            id: 'osm',
            title: 'OpenStreetMap',
            type: 'base',
            visible: false,
            source: new OSM()
        }),
        new TileLayer({
            id: 'top_open_plus',
            title: 'TopOpenPlus grau',
            type: 'base',
            visible: true,
            source: new XYZ({
                url: 'https://sgx.geodatenzentrum.de/wmts_topplus_open/tile/1.0.0/web_grau/default/WEBMERCATOR/{z}/{y}/{x}.png  '
            })
        }),
        new TileLayer({
            id: 'google_sat',
            title: 'Google Satellite',
            type: 'base',
            visible: false,
            source: new XYZ({
                url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
            })
        }),

    ]
});



export { BASELAYER, survLayer, survSource, survVectorTemp, survSourceTemp };

